// extracted by mini-css-extract-plugin
export default {"priceContainer":"ctslix4me","oldPrice":"ckfvl1e77","newPrice":"cnkhd9ph0"};